:host {
  position: absolute;
  padding: var(--tab-body-padding-top) var(--tab-body-padding-right) var(--tab-body-padding-bottom)
    var(--tab-body-padding-left);

  .gz-tab-wrap {
    height: 100%;
    width: 100%;
    display: block;
    transition: opacity 200ms ease-out, transform 200ms ease-in;
  }

  .tab-selected {
    position: relative;
    transform: translate(0);
    opacity: 1;
    z-index: 1000;
  }

  .tab-hidden {
    display: none;
  }

  .tab-visible {
    display: block;
  }

  .tab-not-selected {
    position: absolute;
    pointer-events: none;
    transform: translate(5px);
    opacity: 0;
  }
}

:host([selected]) {
  z-index: 1;
}
